import { MonsterBrainIds } from "../../monster/MonsterBrainIds";
import PathPlanFinder from "../../path/PathPlanFinder";
import MoveTurnAction from "../turn/MoveTurnAction";
import CharacterBrain from "./CharacterBrain";
import MonsterWanderBehavior from "./MonsterWanderBehavior";

export default class CharacterBrains {
    /**
     * @param {PathPlanFinder} pathPlanFinder 
     */
    constructor(pathPlanFinder) {

        /**
         * @constant
         * @type {TurnAction}
         */
        this.moveTurnAction = new MoveTurnAction();
        
        /**
         * @private
         * @constant
         * @type {MonsterWanderBehavior}
         */
        this.monsterWanderBehavior = new MonsterWanderBehavior(1, pathPlanFinder, this.moveTurnAction); 

        /**
         * @constant
         * @type {Object}
         */
        this.brainById = {};

        /**
         * @constant
         * @type {CharacterBrain}
         */
        this.basicMonsterBrain = new CharacterBrain(MonsterBrainIds.BASIC, [
            this.monsterWanderBehavior
        ]);

        this.brainById[this.basicMonsterBrain.id] = this.basicMonsterBrain;
    }

    /**
     * @param {string} brainId 
     * @returns {CharacterBrain}
     */
    getBrainById(brainId) {
        return this.brainById[brainId];
    }
}